module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDBoNjQwdjQ4MC4wMDNIMHoiLz4KICAgIDxwYXRoIGZpbGw9IiNhYjIzMWQiIGQ9Ik0wIDBoNjQwdjE5Mi4wMDFIMHpNMCAyODguMDAyaDY0MHYxOTIuMDAxSDB6Ii8+CiAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/lv.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/lv.svg
// module chunks = 0